<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_bilgileri"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">
<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_ismi" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>



<div class="grid"><div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.tedarikci_kodu}}:</p></div><!----><div class="col-9 md:col-10"><p class="click_edit_value animate_class">{{item.suppliercode}}</p></div></div>


<template v-if="item.brand.show_suppliers_address">
  
<ClickEditSelect   :title="$store.state.languages.lang_phrases.ulke" :value="item.location.country_id" valkey="country_id" @dataChanged="dataChanged"  :options="countries" :filter="true"  :color_selector="false" />

<ClickEditSelect   :title="$store.state.languages.lang_phrases.sehir" :value="item.location.city_id" valkey="city_id" @dataChanged="dataChanged"  :options="cities" :filter="true"  :color_selector="false" />

<ClickEditInputText  :title="$store.state.languages.lang_phrases.adres" :value="item.location.address" valkey="address" @dataChanged="dataChanged"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.posta_kodu" :value="item.location.zipcode" valkey="zipcode" @dataChanged="dataChanged"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.enlem" :value="item.location.latitude" valkey="latitude" @dataChanged="dataChanged"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.boylam" :value="item.location.longitude" valkey="longitude" @dataChanged="dataChanged"></ClickEditInputText>
</template>






<!--<ClickEditInputText  title="Tedarikçi Kodu" :value="item.suppliercode" valkey="suppliercode" @dataChanged="dataChanged"></ClickEditInputText>-->



<div class="grid" >

<div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.marka_bildirisi}}:</p></div>
<div class="col-9 md:col-10">
<Button type="button"  :label="$store.state.languages.lang_phrases.goruntulemek_icin_tiklayin" @click="showBrandInfo" icon="pi pi-eye"  class="p-button-primary p-button-outlined p-button-sm mr-2 mt-3"   />
</div>
</div>

<div class="grid" v-if="brand_decleration_file">

<div class="col-3 md:col-2"><p class="click_edit_value_title">{{$store.state.languages.lang_phrases.marka_aciklama_dosyasi}}:</p></div>
<div class="col-9 md:col-10">
<small><a :href="apiurl+'uploads/'+brand_decleration_file.filepath" target="_blank" class="p-link mt-4 text-sm block">{{brand_decleration_file.filename}}</a></small>
</div>
</div>

<Accordion :multiple="true">
  <AccordionTab v-for="attributegroup in attributegroups">
    <template #header>
      <span class="flex align-items-center gap-2 w-full">
          <span class="font-bold white-space-nowrap">{{getTheTranslation(attributegroup,"translation")}}</span>
          <Badge :value="attributegroup.customattributes.length" class="ml-auto" />
      </span>
    </template>
    <template v-for="attribute in attributegroup.customattributes">
  <template v-if="attribute.supplierattributes.length">
  

    <CustomAttributeEditor :attribute="attribute" :item_id="item.id"  @dataReneved="dataReneved"/>



  

</template>
</template>

    </AccordionTab>
</Accordion>

<!--
<Panel toggleable collapsed v-for="attributegroup in attributegroups">
<template #header>
  <div class="flex align-items-center gap-2">      
      <span class="font-bold">{{getTheTranslation(attributegroup,"translation")}}</span>
  </div>
</template>

<template v-for="attribute in attributegroup.customattributes">
  <template v-if="attribute.supplierattributes.length">
  
  <template v-if="attribute.type=='string'">
      <ClickEditInputText  :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutetextval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged"></ClickEditInputText>
    
  </template>

  <template v-if="attribute.type=='number'">
    <ClickEditNumber   :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged" />
  </template>

  <template v-if="attribute.type=='boolean'">
    <ClickEditSwitch    :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged" />
  </template>

  <template v-if="attribute.type=='categorised'">
    <ClickEditCategory   :allcategories="attribute.categories" :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
  </template>

  <template v-if="attribute.type=='cascadecategorised'">
    <ClickEditCascadeCategory   :allcategories="attribute.categories" :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
  </template>

  <template v-if="attribute.type=='select'">
    <ClickEditSelect    :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" valkey="languages" :options="attribute.options"  :read_only="!attribute.supplier_can_edit" :color_selector="true"/>
    
    
  </template>

</template>
</template>


</Panel>

-->



<!-- ungrouped-->

<template v-for="attribute in attributes">
  <template v-if="attribute.supplierattributes.length">
  
  
<CustomAttributeEditor :attribute="attribute" :item_id="item.id"  @dataReneved="dataReneved"/>

</template>
</template>

<!-- ungrouped-->


</div>

<Dialog :header="item.brand.name + ' '+$store.state.languages.lang_phrases.marka_bildirisi" v-model:visible="show_brand_info" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '80vw'}" :modal="true">

<ScrollPanel style="width: 100%; height: 500px">

<div v-for="translation in item.brand.translations"  v-html="translation.description"> </div>
</ScrollPanel>




</Dialog>


</template>









</div>



</template>

<script>
import CustomAttributeEditor from "./CustomAttributeEditor"
export default {

  name: 'SupplierBrandGeneral',

  data () {
    return {
    	item:null,
      	loading:true,     
      	attributes:[],
        attributegroups:[],
      	show_brand_info:false,   
        countries:[],   
        cities:[],
    }
  },
  components:{CustomAttributeEditor},
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"marka") 
    console.log(this.$route.params)
    this.getData()
  },
  computed:{
    brand_decleration_file()
    {
      
      let translations = this.item.brand.translations
      let selected = translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      if(selected && selected.filepath)
      {
        console.log("selected")
        console.log(selected)
        return selected
      }
      else
      {
        return false
      }
    },
    apiurl()
    {
      return "https://storage.googleapis.com/verifycloud/"
      let api =  process.env.VUE_APP_API_HOOK
      api = api.replace("/api/","/")
      return api
      //return "https://storage.googleapis.com/verifycloud/"
    },
  },
  methods:{
    showBrandInfo()
    {
      this.show_brand_info = true
    },
    async getData()
    {
        this.countries = await this.generalApiGetWithoutLoader("countries")
        this.item = await this.generalApiGetWithoutLoader("get_brand_data_for_supplier/"+this.$route.params.supplier_uuid)
        console.log(this.item)
        

        this.attributes = await this.generalApiGetWithoutLoader("supplier_brand_attributes_without_groups/"+this.$route.params.supplier_uuid)

        this.attributegroups = await this.generalApiGetWithoutLoader("supplier_brand_attributes_with_groups/"+this.$route.params.supplier_uuid)

        console.log(this.attributes)
        if(this.item.location.country_id)
        {
          this.getCities(this.item.location.country_id)
        }
        this.$store.dispatch('suppliers/setSupplier',this.item) 
        this.loading = await false
    },
    async getCities(country_id)
    {
      this.cities = await this.generalApiGetWithoutLoader("cities/"+country_id) 
      console.log("cities")
      console.log(this.cities)
    },
    dataChanged(data)
    {
      if(data.key=="country_id")
      {
        this.getCities(data.value)
      }
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"supplier/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      this.getData()
            
    },
    attributeChanged(data)
    {
      console.log(data)
      //return false
      let formdata = new FormData()
      formdata.append("data",data.value)
      formdata.append("customattribute_id",data.key)
      this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.item.id,this.afterdataChanged)
    },
    dataReneved()
    {
      this.getData()
    },

  }
}
</script>

<style lang="css" scoped>
</style>